import { ClientsSettingsWrapper } from "./clients-settings-wrapper";

export default function ClientsSettingsPage() {
  return <ClientsSettingsWrapper />;
}
